module.exports = __webpack_public_path__ + "img/Bodice-Front-B5-Jc.9453dc88.png";